import { useQuery } from '@mint-lib/query-client';
import { Auth } from '@mint-sdk/api-auth';

import {
  userColumnsFallback,
  type UserColumnConfig,
} from './userColumnsConfig.js';

export const useUsersColumns = () => {
  const query = useQuery({
    ...Auth.listUsersColumns({}),
    refetchOnWindowFocus: false,
  });

  const columns: UserColumnConfig[] = query.isError
    ? userColumnsFallback
    : (query.data ?? userColumnsFallback);

  return {
    columns,
    isLoading: query.isLoading,
    isError: query.isError,
  };
};
